// O relatório de relatos — o que a família viu e anotou no quarto.
//
// Saiu do acompanhamento a pedido do Ilton (25/09): lá os relatos ocupavam
// quase metade do documento e empurravam os exames para longe de quem lê.
// Aqui ficam inteiros, por dia, com hora e autor — é o material de onde se
// tiram conclusões cruzando com os números, não um resumo deles.
import { formatarData, formatarDataHora, formatarHora } from '@medicov1/shared';
import { LEGENDA_DOS_RELATOS, rotuloDoDia, type RelatosDTO } from './relatorioRelatosTipos';
import { NotaFormatada } from './NotaFormatada';

export type { RelatosDTO } from './relatorioRelatosTipos';

export function FolhaRelatos({ dados }: { dados: RelatosDTO }) {
  const p = dados.paciente;
  return (
    <article className="doc doc--relatos">
      <header className="doc__cabeca">
        <div>
          <h1>{p.apelido}</h1>
          <p className="doc__quem">
            {p.idade} anos{p.quarto && <> · quarto <b>{p.quarto}</b></>} · internada desde {formatarData(p.internadoDesde)}
          </p>
        </div>
        <div className="doc__selo">
          <span>Relatos da família</span>
          <small>{dados.gerado.periodoRotulo}</small>
          <small>gerado em {formatarDataHora(new Date(dados.gerado.em))}</small>
        </div>
      </header>

      <p className="doc__aviso">{LEGENDA_DOS_RELATOS}</p>

      {dados.total === 0 ? (
        <p className="doc__legenda">Nenhum relato neste período.</p>
      ) : (
        <p className="doc__legenda">
          <b>{dados.total}</b> {dados.total === 1 ? 'relato' : 'relatos'} em{' '}
          <b>{dados.dias.length}</b> {dados.dias.length === 1 ? 'dia' : 'dias'}
          {dados.autores.length > 0 && <>, escritos por {dados.autores.join(', ')}</>}.
        </p>
      )}

      {dados.dias.map((d) => (
        <section className="doc__bloco" key={d.dia}>
          <h2>
            {rotuloDoDia(d.dia)}
            <small>{d.relatos.length === 1 ? 'um relato' : `${d.relatos.length} relatos`}</small>
          </h2>
          <ul className="doc__lista doc__lista--tempo">
            {d.relatos.map((r, i) => (
              <li key={i}>
                <div className="doc__lista__linha">
                  <b className="doc__quando">{formatarHora(new Date(r.ocorreuEm))}</b>
                  <span className="fraco">{r.autor}</span>
                </div>
                <NotaFormatada texto={r.texto} />
              </li>
            ))}
          </ul>
        </section>
      ))}
    </article>
  );
}
